// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6177":"1443ee5e","9740":"1443ee5e"}[chunkId] + ".chunk.css";
};